module.exports = __webpack_public_path__ + "img/group.a7664ca8.png";